/**
 * create-aggregator-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AggregatorDescriptor }
  from "../../../aggregation/aggregator-descriptor";
import { SubjectContextType } from "../../../subjects/subject-context-type";
import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class CreateAggregatorRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CREATE_AGGREGATOR;
	public static tag : MessageTag = MessageTag.REQ_CREATE_AGGREGATOR;

  /**
   * Construct a new {@link CreateAggreagatorRequest}.
   */
  constructor (
    public aggregator : string,
    public algorithm : string,
    public subjectContextType : SubjectContextType,
    public groupId : number
  )
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_CREATE_AGGREGATOR);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/create-aggregator-request.ts